/* eslint-disable react/jsx-key */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useEffect, useCallback } from 'react'
import { DatePicker, Spin, Icon } from 'antd'
import { getCard95, lockCard95Data } from 'api/pgads'
import { HeaderTag } from './Card95EditPromptAntd'
import moment from 'moment'
import { UtilityUnitSelection } from 'core'
import { List } from 'immutable-ext'
import Task from 'data.task'
import { LockCheckFunc } from '../../Card95Antd'
const InsertHeader = ({
  apiTargetInfo,
  // utilityNameMap,
  // unitNameMap,
  // utilityUnitMap,
  handleChange,
  state,
  setInsertData,
  // headers,
  mode,
  setMode,
  setError,
  setLoading,
  setShowEditDialog,
  loading,
  clearData,
  dataModified = false,
  disableComp,
  ...prop
}) => {
  const insertDate = moment()

  const {
    utility,
    unit,
    year = prop.year || parseInt(insertDate.format('YYYY')),
    month = prop.month || parseInt(insertDate.format('MM')),
  } = state

  insertDate.month(month - 1).year(year)

  const onRetrieveData = useCallback(
    _ => {
      if (
        utility === undefined ||
        unit === undefined ||
        utility == null ||
        unit == null ||
        mode === 'D' ||
        mode === 'V'
      ) {
        return
      }
      setLoading(true)

      List.of(
        getCard95(apiTargetInfo)(
          year,
          month,
          utility,
          [unit],
          year,
          month,
          true
        ),
        lockCard95Data(apiTargetInfo)({
          year: year,
          month: month,
          units: [unit],
          endYear: year,
          endMonth: month,
        })
      )
        .traverse(Task.of, _ => _)
        .fork(
          e => setError(e, _ => setShowEditDialog(false)),
          dataList => {
            setLoading(false)
            const lockData = dataList.get(1)
            const data = dataList.get(0)
            const lockStatus = LockCheckFunc(
              lockData,
              data[0] || { year, month, unit, utility }
            ) || {
              lock: 'U',
            }
            // data[0].mode==='U' means dara came from card95 table
            // data[0].mode==='N' means record geneterd from pacakge for INSERT
            if (data.length > 0) {
              clearData()
              setInsertData({ ...data[0], lock: lockStatus.lock })
              const { mode = 'U' } = data[0] || {}
              if (mode === 'U') setMode('E')
              if (mode === 'N') setMode('N')
            } else {
              clearData()
              setInsertData({
                utility,
                unit,
                month,
                year,
                lock: lockStatus.lock,
              })
              handleChange(null, { name: 'loadChar', value: '1' }, false)
              setMode('N')
            }
          }
        )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      apiTargetInfo,
      clearData,
      handleChange,
      // mode,
      month,
      setError,
      setInsertData,
      setLoading,
      setMode,
      unit,
      utility,
      year,
    ]
  )

  useEffect(onRetrieveData, [onRetrieveData])

  return (
    <Spin spinning={loading} indicator={<React.Fragment />}>
      <HeaderTag
        style={{
          verticalAlign: 'middle',
          alignSelf: 'center',
          // gridRowEnd: 'span 2',
          gridColumnEnd: 'span 4',
          textAlign: 'center',
          color: 'darkblue',
        }}
      >
        {mode === 'D' ? (
          <span>
            {disableComp && <Icon type="lock" />} {'  '}Delete Data
          </span>
        ) : mode === 'N' ? (
          <span>
            {disableComp && <Icon type="lock" />} {'  '}New Data
          </span>
        ) : mode === 'E' ? (
          <span>
            {disableComp && <Icon type="lock" />} {'  '} Edit Data
          </span>
        ) : (
          'View Data'
        )}
      </HeaderTag>

      <div
        style={{
          justifyContent: 'space-around',
          backgroundColor: '#e6f7ff',
          display: 'grid',
          gridTemplateColumns: '2fr 12fr 2fr 5fr',
          gridColumnGap: '15px',
          padding: '0px 5px 10px',
        }}
      >
        <div style={{ padding: '10px 0px 0px', gridColumnEnd: 'span 2' }}>
          Utility / Unit
        </div>
        <div style={{ padding: '10px 0px 0px', gridColumnEnd: 'span 2' }}>
          Month
        </div>

        <UtilityUnitSelection
          defaultValue={[utility, unit]}
          utility={utility}
          unit={unit}
          onUnitChange={value => {
            handleChange(null, { name: 'lock', value: undefined }, false)
            handleChange(null, { name: 'utility', value: value[0] }, false)
            handleChange(null, { name: 'unit', value: value[1] }, false)
          }}
          style={{ gridColumnEnd: 'span 2' }}
          disabled={mode === 'D' || mode === 'V' || dataModified}
        />

        <DatePicker.MonthPicker
          style={{ alignSelf: 'center', gridColumnEnd: 'span 2' }}
          format="MMMM-YYYY"
          allowClear={false}
          value={insertDate}
          onChange={date => {
            handleChange(null, { name: 'lock', value: undefined }, false)
            handleChange(
              null,
              {
                name: 'year',
                value: parseInt(date.format('YYYY')),
              },
              false
            )
            handleChange(
              null,
              {
                name: 'month',
                value: parseInt(date.format('MM')),
              },
              false
            )
            // handleChange(null, { name: 'insertDate', value: date })
          }}
          disabled={mode === 'D' || mode === 'V' || dataModified}
        />
      </div>
    </Spin>
  )
}

export default InsertHeader
